var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d9d9d9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.138.64a7.5,7.5,0,1,0,7.5,7.5,7.508,7.508,0,0,0-7.5-7.5Zm6.4,7.5a6.369,6.369,0,0,1-1.325,3.891,1.02,1.02,0,0,1-.249-1.19A5.667,5.667,0,0,0,13.2,8.666c-.052-.464-.293-1.582-.948-1.593a1.512,1.512,0,0,1-1.493-1c-.807-1.616,1.515-1.926.708-2.819C11.246,3,10.078,4.285,9.907,2.573a.9.9,0,0,1,.263-.5A6.408,6.408,0,0,1,14.536,8.14ZM7.26,1.807c-.153.3-.557.419-.8.644-.534.483-.764.417-1.052.88S4.182,4.462,4.182,4.8s.472.731.708.655a2.521,2.521,0,0,1,1.224.055c.366.13,3.057.259,2.2,2.534-.272.724-1.463.6-1.78,1.8a9.5,9.5,0,0,0-.223,1.172c-.02.38.269,1.811-.1,1.811s-1.358-1.28-1.358-1.513A14.72,14.72,0,0,1,4.6,9.569c0-.7-1.186-.685-1.186-1.611,0-.834.643-1.25.5-1.651S2.641,5.9,2.17,5.847A6.415,6.415,0,0,1,7.26,1.806ZM6.126,14.21c.384-.2.423-.466.772-.479a6.96,6.96,0,0,0,1.172-.255,10.808,10.808,0,0,1,1.739-.543c.53-.043,1.574.027,1.855.538a6.366,6.366,0,0,1-5.538.738Z",
    transform: "translate(-0.638 -0.64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.3414e76e.svg";
export { ForwardRef as ReactComponent };